// ---------------------------------------------------------------
// noteService.js — Bloc de notas del administrador.
// Colección `notes`: { ownerUid, title, body, createdAt, updatedAt }.
// Cada admin ve SÓLO los suyos: las reglas de Firestore filtran por
// ownerUid, así que no basta con que la interfaz los oculte.
// ---------------------------------------------------------------
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { sharedSubscribe } from "../utils/sharedSnapshot";

/** Documentos de UN admin, ordenados por última modificación */
export function subscribeNotes(uid, onData, onError) {
  if (!uid) {
    onData([]);
    return () => {};
  }
  return sharedSubscribe(
    `notes:${uid}`,
    (cb, err) =>
      onSnapshot(
        query(
          collection(db, "notes"),
          where("ownerUid", "==", uid),
          orderBy("updatedAt", "desc")
        ),
        (snap) => cb(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
        err
      ),
    onData,
    onError
  );
}

export function createNote(uid, title = "Documento sin título") {
  return addDoc(collection(db, "notes"), {
    ownerUid: uid,
    title,
    body: "",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export function saveNote(noteId, { title, body }) {
  const patch = { updatedAt: serverTimestamp() };
  if (title !== undefined) patch.title = title;
  if (body !== undefined) patch.body = body;
  return updateDoc(doc(db, "notes", noteId), patch);
}

export function deleteNote(noteId) {
  return deleteDoc(doc(db, "notes", noteId));
}
